import { ProcessedSearchResultItem } from '@app/data/clients/rbServerSideClient/queries/GetSearchResults/types';
import Box from '@redbubble/design-system/src/Box';
import * as constants from '@redbubble/design-system/src/constants';
import Image from '@redbubble/design-system/src/Image';
import Text from '@redbubble/design-system/src/Text';
import { defineMessages, useIntl } from '@redbubble/next/intl';
import {
  MatureContentCover,
  MatureContentCoverStyle,
} from '../../../../components/MatureContentCover';
import styles from './ArtworkInfo.module.scss';

interface ArtworkInfoProps {
  inventoryItem: ProcessedSearchResultItem;
  sectionTitle: string;
}

const messages = defineMessages({
  imageAltText: {
    defaultMessage: 'Artwork thumbnail, {workTitle} by {artistName}',
  },
});

export const ArtworkInfo: React.FC<ArtworkInfoProps> = ({
  inventoryItem,
  sectionTitle,
}) => {
  const intl = useIntl();
  const { work } = inventoryItem;
  const productTitle = `${work.title} ${inventoryItem.description}`;

  return (
    <Box className={styles.container}>
      <Box className={styles.imageContainer}>
        <MatureContentCover
          aspectRatioHeight={1}
          styleType={MatureContentCoverStyle.EyesOnly}
          matureContent={work.matureContent}
        >
          <Image
            src={
              inventoryItem.previewSet?.previews &&
              inventoryItem.previewSet.previews[0].url
            }
            size={constants.SMALL}
            ratio={constants.RATIO_SQUARE}
            alt={intl.formatMessage(messages.imageAltText, {
              workTitle: work.title,
              artistName: work.artistShopDisplayName,
            })}
            fluid
            roundedCorners
          />
        </MatureContentCover>
      </Box>
      <Box className={styles.titleContainer}>
        <Text type="body">{sectionTitle}</Text>
        <Text type="display5" className={styles.title}>
          {productTitle}
        </Text>
      </Box>
    </Box>
  );
};
